import { EMPTY_STRING } from '../../constants/common'
import { DEFAULT_TEXT_SEPARATOR } from '../../constants/generate'
import { htmlToMultilineText } from '../../utils/html'

import {
  AI_NOTICE_HTML_STYLE,
  AITextGenerationApplyAction,
  AITextGenerationFieldMode,
} from './AITextGenerationField.constants'

export function isAITextGenerationFieldModeDraft(mode) {
  return mode === AITextGenerationFieldMode.Draft
}

export function getAITextGenerationNoticeHtml({ noticeText, showAiNotice }) {
  return showAiNotice
    ? `<p style="${AI_NOTICE_HTML_STYLE}">${noticeText}</p>`
    : EMPTY_STRING
}

export function isAIActionApply(action) {
  return action === AITextGenerationApplyAction.Apply
}

export function isAIActionInsertBelow(action) {
  return action === AITextGenerationApplyAction.InsertBelow
}

export function isAIActionReplace(action) {
  return action === AITextGenerationApplyAction.Replace
}

export function applyAITextToWysiwygField({
  action,
  currentValue,
  editorRef,
  generatedText,
}) {
  const nextValue = isAIActionInsertBelow(action)
    ? `${currentValue || EMPTY_STRING}${generatedText}`
    : generatedText

  editorRef?.current?.setContent(nextValue)

  return nextValue
}

export function applyAITextToTextareaField({
  action,
  currentValue,
  generatedText,
  maxLength,
  separator = DEFAULT_TEXT_SEPARATOR,
}) {
  const plainText = htmlToMultilineText(generatedText)

  const merged =
    isAIActionInsertBelow(action) && currentValue
      ? `${currentValue}${separator}${plainText}`
      : plainText

  return maxLength ? merged.slice(0, maxLength) : merged
}
